module.exports = __webpack_public_path__ + "img/logo.6ee85169.png";